const getCurrentDate = () => {
    const date = new Date()
    let dd = date.getDate()
    let mm = date.getMonth() + 1
    let yyyy = date.getFullYear()
    if (dd < 10) {
        dd = '0' + dd
    }
    if (mm < 10) {
        mm = '0' + mm
    }
    return `${yyyy}-${mm}-${dd}`
}
export default [
    {
        field: 'code',
        type: 'text',
        value: '',
        vuetifyProps: {
            disabled: true,
            label: 'Código',
        },
    },
    {
        field: 'g_generator_user_id',
        type: 'text',
        value: '',
        vuetifyProps: {
            disabled: true,
            label: 'Responsable',
        },
    },
    {
        field: 'date',
        type: 'datePicker',
        value: getCurrentDate(),
        vuetifyProps: {
            label: 'Fecha',
        },
        rules: ['required'],
    },
    {
        field: 'acc_accounting_seat_type_id',
        type: 'autocompleteObject',
        value: '',
        vuetifyProps: {
            label: 'Tipo',
        },
        options: {
            data: [
                {
                    id: 0,
                    concept: 'Esperando base de datos...',
                },
            ],
            text: 'type',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'expected_amount',
        type: 'text',
        format: 'currency',
        value: 0,
        vuetifyProps: {
            label: 'Balance Esperado',
        },
    },
    {
        field: 'acc_accounting_seat_concept_id',
        type: 'autocompleteObject',
        value: '',
        vuetifyProps: {
            label: 'Concepto',
        },
        options: {
            data: [
                {
                    id: 0,
                    concept: 'Esperando base de datos...',
                },
            ],
            text: 'concept',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'comment',
        type: 'textarea',
        vuetifyProps: {
            label: 'Glosa',
            'single-line': true,
            outline: true,
        },
        rules: ['required'],
        value: '',
    },
]
